function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,30.196078%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 10.6875 68.28125 L 4.453125 0 L 71.398438 0 L 65.3125 68.28125 L 38 76 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(16.078431%,39.607843%,94.509804%)",
      fillOpacity: 1
    },
    d: "M 38 5.492188 L 38 70.0625 L 60.117188 63.976562 L 65.3125 5.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 16.921875 13.953125 L 38 13.953125 L 38 22.265625 L 17.664062 22.265625 M 18.40625 30.875 L 38 30.875 L 38 39.335938 L 19.148438 39.335938 M 19.59375 43.492188 L 27.90625 43.492188 L 28.5 50.171875 L 38 52.695312 L 38 61.453125 L 20.632812 56.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38 30.875 L 38 39.335938 L 48.242188 39.335938 L 47.203125 50.171875 L 38 52.695312 L 38 61.453125 L 55.070312 56.703125 L 58.929688 13.953125 L 38 13.953125 L 38 22.265625 L 49.875 22.265625 L 49.058594 30.875 Z M 38 30.875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.2a56a567f03dc19294a900fc89bbebc6.svg";
export { ForwardRef as ReactComponent };